import { useLazyQuery } from '@vue/apollo-composable'
import * as api from '@/api/okaso-api'
import { useAuthFunc } from '@/utils/auth'
import { ApolloQueryResult } from '@apollo/client'

export function useGetCustomerFunc() {

  const getWhere = (usernameAuthSub?: string) => {
    const authUtil = useAuthFunc()
    const sub = usernameAuthSub || authUtil.getAuthSub()
    const where: api.CustomerWhereInput  = {
      usernameAuthSub: {
        equals: sub
      }
    }
    return where
  }

  const {
    load: getCustomerLoad,
    refetch: getCustomerRefetch,
    onResult: getCustomerOnResult,
    onError: getCustomerOnError
  } = useLazyQuery<
    api.FindFirstCustomerByUserAuthSubQuery,
    api.FindFirstCustomerByUserAuthSubQueryVariables
  >(api.FindFirstCustomerDocument, undefined)

  const getCustomerFetchOrRefetch = async (variables:api.FindFirstCustomerByUserAuthSubQueryVariables) => {
    return await getCustomerLoad(api.FindFirstCustomerDocument, variables) || await getCustomerRefetch(variables)
  }

  const getCustomer = async (usernameAuthSub?: string) => {
    console.log('getCustomer')
    const where = getWhere(usernameAuthSub)
    // 検索実行
    const res = await getCustomerFetchOrRefetch({
      where,
    }) as ApolloQueryResult<api.FindFirstCustomerByUserAuthSubQuery>

    if (res) {
      console.log(res)
      if (res.data && res.data?.findFirstCustomer) {
        return res.data.findFirstCustomer as api.Customer
      } else {
        return undefined
      }
    }
      }

  return {
    getCustomer,
    getCustomerOnResult,
    getCustomerOnError
  };
}